import { Grid, TextField } from "@mui/material";

/**
 * An address in the four parts a government form prints separately. The free-text address kept
 * elsewhere on the agent stays as the human-readable summary; this is what gets stamped into boxes.
 */
const AddressPartFields = ({ value, onChange }) => {
  const field = (key) => (event) => onChange({ ...value, [key]: event.target.value });

  return (
    <>
      <Grid item xs={12}>
        <TextField
          label="Street address"
          size="small"
          fullWidth
          value={value.street}
          onChange={field("street")}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          label="Suburb / town / state"
          size="small"
          fullWidth
          value={value.suburb}
          onChange={field("suburb")}
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <TextField
          label="Country"
          size="small"
          fullWidth
          value={value.country}
          onChange={field("country")}
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <TextField
          label="Postcode"
          size="small"
          fullWidth
          value={value.postcode}
          onChange={field("postcode")}
        />
      </Grid>
    </>
  );
};

export default AddressPartFields;
